import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface SmartContractExpenseImportsKeyType {
  url: LocalesKey;
  status: LocalesKey;
  smartContractExpenseImports: LocalesKey;
  importSmartContractExpenseImports: LocalesKey;
  progress: LocalesKey;
  rowCount: LocalesKey;
  errorMessage: LocalesKey;
  searchByKey: LocalesKey;
  searchById: LocalesKey;
  searchByStatus: LocalesKey;
  smartContractId: LocalesKey;
  value: LocalesKey;
  errorBacktrace: LocalesKey;
}

export const smartContractExpenseImportsKeys = keyPathMirror<
  SmartContractExpenseImportsKeyType,
  string
>(
  {
    url: null,
    smartContractExpenseImports: null,
    importSmartContractExpenseImports: null,
    status: null,
    progress: null,
    rowCount: null,
    errorMessage: null,
    searchByKey: null,
    searchById: null,
    searchByStatus: null,
    smartContractId: null,
    value: null,
    errorBacktrace: null
  },
  'models.smartContractExpenseImports.'
);
